/** One import for the three screens that show a list of tasks.
 *
 *  Cards on a phone, the ledger from `md` up. Today, All tasks and Carried forward
 *  all rendered `TaskTable` directly, so making the phone view a *choice* rather
 *  than a second component they each have to remember to use is what stops one of
 *  the three being left behind - which is exactly what happened when `.table-wrap`
 *  was added to fix the same problem the last time.
 *
 *  Its own file rather than a function at the bottom of either: `TaskCards` reads
 *  `groupRows` out of `TaskTable`, so a switch living in one of them would make the
 *  two import each other.
 */
import type { Task } from '@/api/client'
import { useNarrow } from './ui'
import type { Selection } from './Selection'
import { TaskCards } from './TaskCards'
import { TaskTable, type GroupBy } from './TaskTable'

export function TaskList(props: {
  tasks: Task[]
  onOpen: (t: Task) => void
  footer?: string
  groupByDate?: boolean
  groupBy?: GroupBy
  /** Forwarded untouched to whichever rendering wins, so ticking works the same on
   *  a phone as on a laptop. Absent means no checkboxes anywhere. */
  selection?: Selection
  /** Open with the company (or person) groups folded. The lists that span weeks
   *  ask for it; Today does not - see `Collapse`. */
  startFolded?: boolean
}) {
  return useNarrow() ? <TaskCards {...props} /> : <TaskTable {...props} />
}
